'use strict';

require('airbnb-js-shims');


//////////////////
// WEBPACK FOOTER
// ./~/@kadira/storybook/dist/server/config/polyfills.js
// module id = 221
// module chunks = 0 1